import { connect } from 'react-redux'
import ReactDOM from 'react-dom'
import SpeedTest from '../../components/tools/SpeedTest.jsx'
import { AffixNewLinkText, AffixNewLinkQrcode, AffixNewLinkHangUp } from '../../components/affix/LinkTextNew.jsx'
import { DOMAIN, DOWNLOAD_WIN, DOMAIN_CHECK, DOWNLOAD_APP_QR,DOWNLOAD_HANGUP_PC, DOWNLOAD_HANGUP_README, ACTIVITY_SOUTHASIA, DOWNLOAD_APP_HANGUP_QR, DOWNLOAD_CEF_PC, DOWNLOAD_FAST_LOGIN, HY_DOWNLOAD_AUTOLOTT_PC } from '../../constants/config'
import volidPng from '../../i/pc-day/login/sidebar_con_xclogo.png'
import login_logo from '../../i/pc-day/df/login_logo.png'

class Login extends React.Component {

  constructor(props) {
    super(props);
    this.login = this.login.bind(this);
    this.loginWithCaptcha = this.loginWithCaptcha.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.togglePasswordType = this.togglePasswordType.bind(this);
    this.checkpopupModal  = this.checkpopupModal.bind(this);
    this.state = {
      passwordType: true,
      display: true,
      showPassword: false,
      saveUser: $.getCookie('_username'),
      popupModal : true,
    }
    this.imgUrl = DOWNLOAD_APP_QR + "?n=" + Math.random()
    this.qrUrl = DOWNLOAD_APP_HANGUP_QR + "?n" + Math.random()
    document.getElementsByTagName('body')[0].style.background = '#fff'

  }

  componentDidMount(){
    this.props.$$COMMON.clearDomainStatus();
    this.props.$$COMMON.getSpeedDomains();
    // 记住上一次密码 
    if ($.getCookie('_username') && $.getCookie('_password')) {
      $.setEleValueById('username', $.getCookie('_username'));
      $.setEleValueById('password', $.getCookie('_password'));
      let state = _.cloneDeep(this.state);
      state['username'] = $.getCookie('_username');
      state['password'] = $.getCookie('_password');
      this.setState(state)
    }
    this.refreshTimer = window.setInterval(function(){
      this.props.$$COMMON.getValidcode();
    }.bind(this), 60000);
  }

  componentWillUnmount(){
    if (this.refreshTimer) {
      window.clearInterval(this.refreshTimer);
    }
    document.getElementsByTagName('body')[0].style.background = '';
  }

  // 忘记密码 
  togglePasswordType(){
    this.setState({
      passwordType: !this.state.passwordType
    })
  }

  // 键盘事件
  handleKeyDown(event){
    if (event.keyCode !== 13) {return;}
    if (this.props.__BASE.toJS().modal.overlay.display){return;}
    this.login();
  }

  // 改变输入
  handleOnChange(key){
    let state = _.cloneDeep(this.state);
    state[key] = $.getEleValueById(key)
    this.setState(state)
  }

  //清除输入框值
  clearInput(key){
    let state = _.cloneDeep(this.state);
    state[key] = '';
    $.setEleValueById(key, state[key]);
    this.setState(state)
  }

  //显示明文密码
  showChangePassword(){
    let passType = ReactDOM.findDOMNode( this.refs.password );
    this.state.showPassword ? passType.type = 'password' : passType.type = 'text'
    this.setState({
      showPassword: !this.state.showPassword
    })
  }

  // 登陆
  login(){
    const public_key = this.props.__COMMON.toJS().settings.public_key;
    const request = {
      username: this.state.username,
      password: this.state.password,
    }
    this.props.$$MY.login(request, '',public_key );
  }

  // 使用验证码登陆
  loginWithCaptcha(validCode){
    const captcha = this.props.__COMMON.toJS().captcha;
    const public_key = this.props.__COMMON.toJS().settings.public_key;
    // 验证码
    if (!captcha) {
      return this.props.$$BASE.openAlert('请正确填写验证码信息');
    }
   
    const request = {
      username: this.state.username,
      password: this.state.password,
      validcode: $.Hex_MD5(validCode.toUpperCase()),
    }
    this.props.$$MY.login(request, captcha.key + ':' + validCode, public_key);
  }

  open(){
    this.props.$$BASE.openAlert('敬请期待！')
  }

  checkpopupModal(){
    this.setState({
      popupModal:false
    })
  }

  render() {
     const { captcha, showCaptcha, speedDomains, checkDomainResult, settings } = this.props.__COMMON.toJS();
    speedDomains ? speedDomains.unshift({domain: window.location.host, key: "5", index: "99"}) : null;
      const __base = this.props.__BASE.toJS();
    return (
      <div className="login-new-containers" style={{ display: this.state.display > 0 ? "block" : "none" }}>
        <div className="login-container">
          <img className="login_logo" src={login_logo} alt="" />
          <div className="login-box" onKeyDown={this.handleKeyDown}>
            <li className="service">
              <a href="http://wpa.qq.com/msgrd?v=3&uin=183919721&site=qq&menu=yes" target="_blank">
                customer service
              </a>
            </li>
            <h2>welcome back</h2>
            <div className="input-box username">
              <i />
              <input
                type="text"
                id="username"
                onChange={() => this.handleOnChange("username")}
                placeholder="enter the account number"
              />
            </div>
            <div className="input-box password">
              <i />
              <input
                type="password"
                ref="password"
                id="password"
                onChange={() => this.handleOnChange("password")}
                placeholder={this.state.passwordType ? "enter the login password" : "enter the withdrawal password"}
              />
            </div>

            <div className="forgot-password clear">
              {this.state.passwordType && (
                <label className="fl rememberpass">
                  <input
                    name="checkbox"
                    type="checkbox"
                    id="remember"
                    defaultChecked={this.state.saveUser}
                    onClick={() => this.setState({ saveUser: !this.state.saveUser })}
                  />
                  <span className="checkPass"> remember password</span>
                </label>
              )}
              <a href="javascript:;" className="forgotpasswd" onClick={this.togglePasswordType}>
                {this.state.passwordType ? "forge password" : "back login"}
              </a>
            </div>
            <a className="button-login pointer" onClick={this.login}>
              {this.state.passwordType ? "login" : "submit"}
            </a>

            {/*<div className='register'>*/}
            {/*没有账号？*/}
            {/*<span>点击注册账号</span>*/}
            {/*</div>*/}
          </div>
        </div>

        {showCaptcha ? (
          <ValidCodeModal
            action={this.loginWithCaptcha}
            captcha={captcha}
            closeFn={this.props.$$COMMON.toggleVaildCode}
            refreshValidcode={this.props.$$COMMON.getValidcode}
          />
        ) : null}
        {this.state.popupModal && <PopupModal close={this.checkpopupModal} />}
        <footer className="login_footer">
          <p>Copyright &copy; Copyright Philippine Government PAGCOR Gaming License Certification</p>
        </footer>
      </div>
    );
  }
}

reactMixin(Login.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __COMMON: state.common
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$MY: bindActionCreators(userAction, dispatch),
    $$BASE: bindActionCreators(baseAction, dispatch),
    $$COMMON: bindActionCreators(commonAction, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login)


/**
 * 验证码输入框
 */
class ValidCodeModal extends React.Component {

  constructor(props) {
    super(props);
    this.handelClick = this.handelClick.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.modalPosition = this.modalPosition.bind(this);
    this.state = {
      canSubmit: false
    }
    window.addEventListener('resize', this.modalPosition)
	  this.validCodeModal = null
  }

  componentDidMount(){
  	//获取ref是异步的，需要
  	setTimeout(()=>{
	    this.modalPosition()
	    this.refs.validcode.focus();
    },1000)
	   
  }

  componentDidUpdate(){
    this.modalPosition()
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.modalPosition, false);
  }

  modalPosition(){
    let modalTop = (window.document.body.offsetHeight - this.validCodeModal.offsetHeight) /2 - 20 + 'px';
    this.validCodeModal.style.top = modalTop;
  }

  handleInputChange(){
  }

  handelClick(){
    const { action } = this.props;
    let validcode = $.getEleValueById('validcode');
    validcode = _.trim(validcode);
    if(validcode.length != 4){
      return alert('请输入四位验证码!')
    }
    action(validcode);
  }

  // 键盘事件
  handleLogin(event){
    if (event.keyCode !== 13) {return;}
    this.handelClick();
  }

  render() {
    const { captcha, closeFn, refreshValidcode } = this.props;
    return (
        <div>
          <div className="code-box" ref={(node)=>{
          	this.validCodeModal=node
          }} onKeyDown={this.handleLogin}>
              <ul className="login_input">
                  <li className="validate-li"><i className="icon ic-code" />
                  <input type="text" id='validcode' maxLength='4' className="input-code" placeholder="输入验证码" />
                  <img src={captcha.image_url ? captcha.image_url : volidPng} title="点击刷新" className="validate pointer" onClick={this.refreshValidcode} />
                  </li>
                  <li><input type="button" id="submitLogin" value="确 定" className="submit-login submitLogin" onClick={this.handelClick} /></li>
              </ul>
          </div>
          <div className='overlay-mask' />
        </div>
    );
  }

}



class PopupModal extends React.Component {

  constructor(props) {
    super(props);
  }
  handleClick(){
    window.location.href =  'https://www.pagcor.ph/regulatory/responsible-gaming.php'
  }
  render() {
    return (
        <div>
            <div className="css-1">
              <div className="modalWrap">
                <div className="content">
                  <i  className="iconClose" onClick={ this.props.close}/>
                  <div className="body">
                    <i className="iconLogo"/>
                    <p className="title">Age Verification</p>
                    <p className="desc">Please verify that you are 21 years old or older to enter this site.</p>
                    <div className="btns">
                      <button className="btn over" onClick={ this.props.close}>I am over 21 years old</button>
                      <button className="btn exit" onClick={ this.handleClick.bind()}>Exit</button>
                    </div>
                  </div>

                  <div className="footer">
                    <i  className="pg1 footer-icon"/>
                    <i  className="pg2 footer-icon"/>
                  </div>
                </div>
              </div>
            </div>
        </div>
    );
  }

}

